<template>
    <section v-if="incidents.length" class="workforce-timesheet-incidents">
        <button
            type="button"
            class="workforce-timesheet-incidents__summary"
            :aria-expanded="expanded ? 'true' : 'false'"
            @click="expanded = !expanded"
        >
            <span>
                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                Табельные инциденты
                <strong>{{ incidents.length }}</strong>
            </span>
            <i :class="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" aria-hidden="true"></i>
        </button>
        <div v-if="expanded" class="workforce-timesheet-incidents__list">
            <article v-for="incident in incidents" :key="incident.id">
                <div>
                    <strong>{{ incident.subject_name || 'Человек не определён' }}</strong>
                    <span>{{ incident.title }}</span>
                    <span
                        v-if="incident.action_hint"
                        class="workforce-timesheet-incidents__action"
                    >
                        {{ incident.action_hint }}
                    </span>
                    <timesheet-conflict-sources :entries="incident.related_entries || []" />
                    <b-button
                        v-if="canResolveInTimesheet(incident)"
                        class="mt-2"
                        size="sm"
                        variant="warning"
                        @click="openUnresolvedResolver(incident)"
                    >
                        <i class="fas fa-link mr-1" aria-hidden="true"></i>
                        Открыть табель и сопоставить
                    </b-button>
                </div>
                <div class="workforce-timesheet-incidents__meta">
                    <span v-if="incident.work_date">{{ formatDate(incident.work_date) }}</span>
                    <span v-if="incident.object">{{ incident.object.name }}</span>
                </div>
            </article>
            <p v-if="limited">
                Показаны первые {{ incidents.length }} инцидентов. Остальные доступны в модуле табелей.
            </p>
        </div>
    </section>
</template>

<script>
import api from '@/utils/api';
import TimesheetConflictSources from '@/views/Timesheets/TimesheetConflictSources.vue';

export default {
    name: 'TimesheetIncidentPanel',
    components: {TimesheetConflictSources},
    data() {
        return {
            incidents: [],
            expanded: false,
            limited: false
        };
    },
    async mounted() {
        await this.load();
    },
    methods: {
        async load() {
            try {
                const response = await api.get('/api/timesheets/incidents', {
                    params: {status: 'open', limit: 100},
                    ignoreModal: true
                });
                this.incidents = Array.isArray(response.data) ? response.data : [];
                this.limited = this.incidents.length >= 100;
            } catch (error) {
                this.incidents = [];
            }
        },
        formatDate(value) {
            const parts = String(value || '').split('-');
            return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : value;
        },
        canResolveInTimesheet(incident) {
            return Boolean(
                incident
                && incident.incident_type === 'unresolved_person'
                && incident.timesheet_id
                && incident.line_id
            );
        },
        openUnresolvedResolver(incident) {
            this.$router.push({
                name: 'timesheet',
                params: {timesheetId: String(incident.timesheet_id)},
                query: {resolve_unresolved_line: String(incident.line_id)}
            }).catch(error => {
                if (!error || error.name !== 'NavigationDuplicated') throw error;
            });
        }
    }
};
</script>

<style scoped>
.workforce-timesheet-incidents {
    margin: 0 0 1rem;
    border: 1px solid #f0ad4e;
    border-radius: 12px;
    overflow: hidden;
    background: #fffdf5;
}

.workforce-timesheet-incidents__summary {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: .75rem 1rem;
    border: 0;
    color: #744210;
    background: #fff3cd;
    text-align: left;
}

.workforce-timesheet-incidents__summary strong {
    display: inline-flex;
    min-width: 1.6rem;
    height: 1.6rem;
    align-items: center;
    justify-content: center;
    margin-left: .35rem;
    border-radius: 999px;
    color: #fff;
    background: #c05621;
}

.workforce-timesheet-incidents__list {
    display: grid;
    gap: .4rem;
    padding: .65rem;
}

.workforce-timesheet-incidents__list article {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding: .6rem .7rem;
    border-radius: 8px;
    background: #fff;
}

.workforce-timesheet-incidents__list article strong,
.workforce-timesheet-incidents__list article span {
    display: block;
}

.workforce-timesheet-incidents__list article span,
.workforce-timesheet-incidents__meta {
    color: #6b7280;
    font-size: .82rem;
}

.workforce-timesheet-incidents__list article .workforce-timesheet-incidents__action {
    margin-top: .2rem;
    color: #744210;
    font-weight: 600;
}

.workforce-timesheet-incidents__meta {
    flex: 0 0 auto;
    text-align: right;
}

.workforce-timesheet-incidents__list p {
    margin: .3rem;
    color: #6b7280;
    font-size: .8rem;
}

@media (max-width: 640px) {
    .workforce-timesheet-incidents__list article {
        flex-direction: column;
        gap: .25rem;
    }

    .workforce-timesheet-incidents__meta {
        text-align: left;
    }
}
</style>
